import React from "react";
import { Typography } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import CustomCard from "../../blocks/Card/Card";

const { Title, Paragraph } = Typography;

const PropertySizeComparisonChart = () => {
  const data = [
    {
      name: "Living Space (sq ft)",
      "This Property": 3872,
      "Market Average": 3000,
    },
    {
      name: "Lot Size (sq ft)",
      "This Property": 16864,
      "Market Average": 10000,
    },
  ];

  return (
    <CustomCard
      title={<Title level={4}>Property Size Comparison</Title>}
      className="card-height"
    >
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip
            labelStyle={{ color: "black" }}
            contentStyle={{
              backgroundColor: "white",
              border: "1px solid #d9d9d9",
              borderRadius: "2px",
            }}
          />
          <Legend />
          <Bar dataKey="This Property" fill="#1890ff" /> {/* Ant Design blue */}
          <Bar dataKey="Market Average" fill="#52c41a" />{" "}
          {/* Ant Design green */}
        </BarChart>
      </ResponsiveContainer>
      <Paragraph style={{ marginTop: 16, textAlign: "center" }}>
        This chart compares the property's living space and lot size to market
        averages. The property is larger than average in both aspects, which
        could be a key selling point.
      </Paragraph>
    </CustomCard>
  );
};

export default PropertySizeComparisonChart;
